<!-- resources/js/Components/CookieBanner.vue -->
<template>
  <div
    v-if="showBanner"
    class="alert alert-dismissible fixed-bottom m-3 d-flex justify-content-center"
    role="alert"
  >
    <div class="c-banner row d-flex justify-content-center align-items-center">
      <div class="col-auto my-2">
        Wir nutzen technisch notwendige Cookies für die Funktionalität und Sicherheit von My Chat Pro.
        <a href="#" class="alert-link">Datenschutzerklärung</a>.
      </div>
      <div class="col-auto">
        <button 
          class="btn btn-primary my-2" 
          @click="acceptCookies"
        >
          Okay
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    if (!this.getCookie('cookie_consent')) {
      this.showBanner = true;
    }
  },
  methods: {
    acceptCookies() {
      this.setCookie('cookie_consent', 'accepted', 365);
      this.showBanner = false;
    },
    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax; Secure";
    },
    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
  },
};
</script>

<style scoped>
.fixed-bottom {
  z-index: 1030;
}

.c-banner{
  border: 1px solid var(--border-primary);
  box-shadow: 0 4px 6px -3px rgba(0, 0, 0, 0.1);
  width: 100vh;
  background-color: var(--background-primary);
  border-radius: 10px;
}
</style>